import React from 'react';
import i18n from 'i18n-js';
import RulesConfirmModal from '../rulesEngine/RulesConfirmModal';

export const getCartLabel = row =>
  [row?.cart_label, row?.cart_code, row?.cart_id]
    .map(value => (value == null ? '' : String(value).trim()))
    .find(value => value !== '') || '';

export const buildCartRemovalMessage = (preview, isSingleOrder) => {
  if (isSingleOrder) {
    const label = getCartLabel(preview?.cart_orders?.[0]);
    return label
      ? i18n.t('order.cartRemovalSingleOrder', {cart: label})
      : i18n.t('order.cartRemovalSingleOrderNoLabel');
  }
  const count = Number(preview?.carted_count) || 0;
  return count === 1
    ? i18n.t('order.cartRemovalOneOrder')
    : i18n.t('order.cartRemovalManyOrders', {count});
};

export const getPreviewFailureMessage = result =>
  Array.isArray(result?.errorMessages) && result.errorMessages.length > 0
    ? result.errorMessages.join(' ')
    : i18n.t('order.cartPreviewFailed');

const CartRemovalConfirmModal = ({visible, message, onConfirm, onCancel}) => (
  <RulesConfirmModal
    visible={visible}
    title={i18n.t('order.cartRemovalTitle')}
    message={message}
    confirmText={i18n.t('order.cartRemovalConfirm')}
    cancelText={i18n.t('order.cartRemovalCancel')}
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);

export default CartRemovalConfirmModal;
